export default "__VITE_ASSET__C4QX144Z__"